import CoordinatesOutOfBounds from './errors/CoordinatesOutOfBounds'
/* Represents access to the underlying map definition format.
 * This data is static.
 */
class GameMap {
  constructor(mapJSON) {
    this._validateMap(mapJSON)

    this.layers            = mapJSON.layers
    this.name              = mapJSON.id
    this.flat              = mapJSON.type === "flat"
    this.tileLibrary       = mapJSON.layers.terrain.tile_library
    this.terrainTileChars  = mapJSON.layers.terrain.tiles
    this.portals           = mapJSON.layers.portals || []
    this.messages          = mapJSON.layers.messages || []
    this.characters        = mapJSON.layers.characters || []
    this.travelerTileChars = mapJSON.traveler_tile_library || []
    this.traveler          = mapJSON.initial_traveler
    this.travelers         = mapJSON.travelers

    this.width            = this.terrainTileChars[0].length
    this.height           = this.terrainTileChars.length

    this.travelerStartX   = mapJSON.layers.locations.initial[0]
    this.travelerStartY   = mapJSON.layers.locations.initial[1]

    if (mapJSON.color_strategy) {
      if (mapJSON.color_strategy.coordinates) {
        this.colorPartition = (x,y) => {

          const xdiff = Math.abs(mapJSON.color_strategy.coordinates[0] - x)
          const ydiff = Math.abs(mapJSON.color_strategy.coordinates[1] - y)
          const distance = Math.sqrt(Math.pow(xdiff,2) + Math.pow(ydiff,2))

          const value = mapJSON.color_strategy.partitions.find( (partition) => {
            return distance < partition[0]
          }) || [0,0]

          return value[1]
        }
      }
      else {
        this.colorPartition = () => { return mapJSON.color_strategy.partition }
      }
    }
    else {
      this.colorPartition = () => { return 0 }
    }
  }

  coordinatesForLocation(locationName) {
    const coordinates = this.layers.locations[locationName]
    if (coordinates) {
      return coordinates
    }
    else {
      throw `Map ${this.name} has no location named ${locationName}`
    }
  }

  nightVisibility() {
    // XXX Experimental
    return 5;
  }

  changeTraveler(travelerName) {
    const traveler = this.travelers.find( (t) => {
      return t.name === travelerName
    })
    if (traveler) {
      this.traveler = traveler
    }
    else {
      const foundTravelers = this.travelers.map( (t) => { return t.name })
      throw `[GameMap] Problem: no traveler on map ${this.name} with name ${travelerName}. Found ${foundTravelers}`
    }
  }


  travelerTile() {
    const traveler = this.travelerTileChars.find( (t) => {
      return t.name === this.traveler.name
    })
    if (traveler) {
      return traveler
    }
    else {
      throw `[GameMap] Problem: no traveler with name ${name}`
    }
  }

  terrainTileAt(x,y) {
    if (this.terrainTileChars[y]) {
      if (this.terrainTileChars[y][x]) {
        const terrainChar = this.terrainTileChars[y][x]
        const tile = this.tileLibrary[terrainChar]
        if (tile) {
          return tile
        }
        else {
          throw `[GameMap] Problem: Char ${terrainChar} at ${x},${y} is not in tile library: ${this.terrainTileChars}`
        }
      }
      else {
        throw new CoordinatesOutOfBounds({
          x: x, 
          y: y,
          width: this.terrainTileChars[y].length,
          height: this.terrainTileChars.length,
          map: this,
        })
      }
    }
    else {
      throw `[GameMap] Problem: map doesn't have a row ${y}`
    }
  }
  portalAt(x,y) {
    const portal = this.portals.find( (portal) => {
      return portal.coordinates[0] === x && portal.coordinates[1] === y
    })
    return portal
  }
  messageAt(x,y) {
    const message = this.messages.find( (message) => {
      return message.coordinates[0] === x && message.coordinates[1] === y
    })
    return message
  }
  characterAt(x,y) {
    const character = this.characters.find( (character) => {
      return character.coordinates[0] === x && character.coordinates[1] === y
    })
    return character
  }

  _validateMap(mapJSON) {
    if (!mapJSON.layers) {
      throw "No layers found in map!"
    }
    if (!mapJSON.layers.locations) {
      throw "No locations in map layers!"
    }
    if (!mapJSON.layers.locations.initial) {
      throw "Map does not have an initial location"
    }
  }
}

export default GameMap
